import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Select, Typography } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../../../knock-design-system';

export const CROSS_SELL_REFERRAL_SOURCE_DEFAULT_OPTION = {
  label: 'Original Source',
  value: 'default',
};

export const REFERRAL_SOURCE_ALERT_DESCRIPTION =
  'By default, prospects will inherit the original source. Only the sources enabled in the Sources section for this property will be available.';

const useCss = makeCss((theme) => ({
  alert: {
    backgroundColor: theme.palette.denim[50],
  },
  selectWrapper: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      padding: '0px 4px',
      transform: 'translate(14px, -8px) scale(0.75)',
    },
  },
  select: {
    width: '360px',
  },
}));

const defaultValue = CROSS_SELL_REFERRAL_SOURCE_DEFAULT_OPTION.value;

const ReferralSource = ({
  referralSource,
  referralSourceOptions,
  updateCrossSell,
}) => {
  const css = useCss();

  const optionsRef = React.useRef([
    CROSS_SELL_REFERRAL_SOURCE_DEFAULT_OPTION,
    ...referralSourceOptions,
  ]);

  const handleOnChange = (value) => {
    const updatedValue = value === defaultValue ? '' : value;
    updateCrossSell(updatedValue);
  };

  return (
    <React.Fragment>
      <div css={css.selectWrapper}>
        <Select
          css={css.select}
          displayEmpty
          id="referral-source"
          label="Source"
          labelId="referral-source-label"
          onChange={handleOnChange}
          options={optionsRef.current}
          size="dense"
          value={referralSource || defaultValue}
          variant="outlined"
        />
      </div>

      <Alert
        css={css.alert}
        description={
          <Typography variant="captionStrong" color="info.900">
            Note:{' '}
            <Typography component="span" variant="caption" color="info.900">
              {REFERRAL_SOURCE_ALERT_DESCRIPTION}
            </Typography>
          </Typography>
        }
        icon={false}
      />
    </React.Fragment>
  );
};

ReferralSource.propTypes = {
  referralSource: PropTypes.string,
  referralSourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  updateCrossSell: PropTypes.func,
};

export default ReferralSource;
